import { Device } from 'mediasoup-client'

export default class Cast {

	device = null
	track = null
	bitmap = null // cache bitmap for undo
	fps = 15
	scale = 0.75
	throttle = 0
	resolution = { width: null, height: null } // track's current resolution (size of the window or screen being shared) *** NOT SURE IF NEEDED ***
	canvas = document.querySelector('#canvas')
	context = this.canvas.getContext('2d', { willReadFrequently: true })
	nav = document.querySelector('nav')
	bubble = document.querySelector('span.bubble')
	button = document.querySelector('button.share')
	preview = document.querySelector('#preview')
	waiting = document.querySelector('#waiting')
	producer = null
	producerTransport = null
	consumer = null
	consumerTransport = null
	video = null

	constructor() {

		this.button.addEventListener('click', () => {
			if(this.button.classList.contains('active')) {
				this.stopCapture()
				return
			}
			this.stream()
		})
	}

	async init(json) {
		console.log(' *** INIT *** ', app.key)
		// console.log('cast:init', json)
		this.device = new Device()
		await this.device.load({ routerRtpCapabilities: json.sfu.rtp })
		if(app.key) { // if host ...
			await this.setupProducer(json.sfu.producer)
			this.nav.classList.remove('hide')
		} else {
			await this.setupConsumer(json.sfu.consumer)
			if(json.producers.length) 
				this.sfu_newProducer({ producerId: json.producers[0] }) // automatically consume the first producer
			else
				this.waiting.classList.remove('hide') // no producers yet
		}
		if(json.guests) this.setGuestCount(json.guests)
	}

	setGuestCount(guestCount) {
		this.bubble.textContent = guestCount
	}

	async stream() {
		await navigator.mediaDevices.getDisplayMedia({
			video: true,
			audio: false
		})
		.then(stream => {
			this.startCapture(stream)
		})
		.catch(error => {
			console.log(error)
		})
	}

	async startCapture(stream) {
		this.button.classList.add('active')
		this.button.textContent = 'Stop Sharing'
		this.preview.classList.remove('hide')
		this.track = stream.getVideoTracks()[0]
		this.track.onended = () => this.stopCapture()
        this.capture()
       	this.producer = await this.producerTransport.produce({
            track: this.canvas.captureStream(this.fps).getVideoTracks()[0],
            codecOptions: { videoGoogleStartBitrate: 1000 },
            // appData: { tag:'screen' }  // tag the source
        })
    }

	stopCapture() {
		this.button.classList.remove('active')
		this.button.textContent = 'Start Sharing'
		this.preview.classList.add('hide')
		if(this.producer) {
			app.socket.send({ type: 'sfu_stopProducer', producerId:this.producer.id })
			this.producer.close()
			this.producer = null
		}
		if (this.track) {
			this.track.stop() // Stop the media track
			this.track = null
		}
		// if (this.canvasStream) {
		// 	this.canvasStream.getTracks().forEach(track => track.stop())
		// 	this.canvasStream = null
		// }
    }

	capture() {
		if (!this.track) return
		const imageCapture = new ImageCapture(this.track)
		const drawFrame = async () => {
			if (!this.track) return
			try {
				const bitmap = await imageCapture.grabFrame()
				const width = Math.round(bitmap.width * this.scale)
				const height = Math.round(bitmap.height * this.scale)
				this.bitmap = bitmap

				if (width !== this.canvas.width || height !== this.canvas.height) {
					this.canvas.width = width
					this.canvas.height = height
				}
				this.context.drawImage(this.bitmap, 0, 0, width, height)
			} catch (error) {
				console.error(error)
			}

			if (typeof this.track.requestVideoFrameCallback === 'function') {
				this.track.requestVideoFrameCallback(drawFrame)
			} else {
				requestAnimationFrame(drawFrame)
			}
		}

		if (typeof this.track.requestVideoFrameCallback === 'function') {
			this.track.requestVideoFrameCallback(drawFrame)
		} else {
			requestAnimationFrame(drawFrame)
		}
	}

	async setupConsumer(consumer) {
		this.consumerTransport = this.device.createRecvTransport(consumer)
		console.log('sfu_consumerTransport', this.consumerTransport.id)
		this.consumerTransport.on('connect', ({ dtlsParameters }, callback, errback) => {
			app.socket.send({ type: 'sfu_connectConsumerTransport', transportId: consumer.id, dtlsParameters })
			callback()
		})
	}

	async setupProducer(producer) {
		console.log('*** DEBUG 1 ***')
		this.producerTransport = this.device.createSendTransport(producer)
		console.log('sfu_producerTransport', this.producerTransport.id)
		this.producerTransport.on('connect', ({ dtlsParameters }, callback, errback) => {
			app.socket.send({ type: 'sfu_connectProducerTransport', transportId: producer.id, dtlsParameters })
			callback()
		})
		this.producerTransport.on('produce', ({ kind, rtpParameters, appData }, callback, errback) => {
			console.log('cast:produce', { kind, rtpParameters })
			app.socket.send({
				type: 'sfu_produce',
				transportId: this.producerTransport.id,
				kind,
				rtpParameters,
				appData
			})
			new Promise((resolve, reject) => this.pendingProduceCallback = { resolve, reject })
			.then(producerId => callback({ id: producerId }))
			.catch(errback)
		})
		this.producerTransport.on('connectionstatechange', (state) => {
			// console.log('connectionstatechange', state)
			if (state === 'connected') {
				// this.monitorProducerStats()
			} else if (state === 'failed') {
				console.error('failed')
			}
		})
	}

	sfu_produced(json) {
		const producerId = json.data.id
		console.log('sfu_produced', producerId)
		if (this.pendingProduceCallback) {
			this.pendingProduceCallback.resolve(producerId)
			this.pendingProduceCallback = null
		}
	} 

	async sfu_consumed(json) {
		console.log('sfu_consumed', json)
		const consumer = await this.consumerTransport.consume({
			id: json.data.id,
			producerId: json.data.producerId,
			kind: json.data.kind,
			rtpParameters: json.data.rtpParameters
		})
		this.consumer = consumer
		const stream = new MediaStream([consumer.track])
		this.video = document.createElement('video')
		this.video.srcObject = stream
		this.video.muted = true
		this.video.playsInline = true
		this.video.addEventListener('loadedmetadata', () => {
			this.waiting.classList.add('hide')
			this.preview.classList.remove('hide')
			this.video.play()
			this.canvas.width = this.video.videoWidth
			this.canvas.height = this.video.videoHeight
			let resizeTimer = null
			const drawFrame = (now, metadata) => {
				if (!this.video || this.video.ended || this.video.srcObject === null) return
				const vw = this.video.videoWidth
				const vh = this.video.videoHeight
				if (this.canvas.width === vw && this.canvas.height === vh && !this.video.paused) {
					this.context.drawImage(this.video, 0, 0, this.canvas.width, this.canvas.height)
				} else {
					if (resizeTimer) clearTimeout(resizeTimer)
					if (!this.video.paused) this.video.pause()
					resizeTimer = setTimeout(() => {
						this.canvas.width = vw
						this.canvas.height = vh
						this.video.play()
					}, 250)
				}
				this.video.requestVideoFrameCallback(drawFrame)
			}
			this.video.requestVideoFrameCallback(drawFrame)
		})
	}

	sfu_newProducer(json) {
		if(app.key) return // only guest should consume
		console.log('sfu_newProducer', json.producerId)
		app.socket.send({
			type: 'sfu_consume',
			transportId: this.consumerTransport.id,
			producerId: json.producerId,
			rtpCapabilities: this.device.rtpCapabilities
		})
	}

	sfu_producerStopped(json) {
		if(app.key) return // only guest should consume
		console.log('sfu_producerStopped', json.producerId)
		this.waiting.classList.remove('hide')
		this.preview.classList.add('hide')
		if(this.video) {
			this.video.srcObject = null
			this.video.remove()
			this.video = null
		}
		this.context.clearRect(0, 0, this.canvas.width, this.canvas.height)
	}

}